"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/fiber_optic_manufacturing.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/drone_assembly_line.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/ai_data_center_rack.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/telecom_tower_installation.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/optical_fiber_testing.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/fpv_drone_racing_tech.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/clean_room_production.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/high_speed_connectivity_hub.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/drone_flight_control_system.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/network_infrastructure_deployment.png"];
export default function Partners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const displayImages = [...galleryImages.slice(0, 10), ...galleryImages.slice(0, 10), ...galleryImages.slice(0, 10)];
  return <section data-section-id="152022" id="partnercarousel" className="dark bg-background text-foreground relative overflow-hidden py-40">
      {}
      <div className="pointer-events-none absolute left-1/4 top-1/2 h-96 w-96 -translate-y-1/2 rounded-full bg-primary/10 blur-[120px]" />
      <div className="pointer-events-none absolute right-1/4 top-1/2 h-96 w-96 -translate-y-1/2 rounded-full bg-cyan-500/10 blur-[120px]" />

      <div className="w-full" ref={ref}>
        <div className={`flex flex-col items-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="container mx-auto px-4">
            <h2 className="mb-16 text-center text-3xl font-bold tracking-tighter text-primary md:text-4xl lg:text-5xl">NEXEL is Trusted Across Industries</h2>
          </div>

          <div className="css-carousel relative w-full overflow-hidden px-4 md:px-10">
            <style>
              {`
                @keyframes marquee-scroll {
                  0% { transform: translateX(0); }
                  100% { transform: translateX(-33.333%); }
                }
                .animate-marquee-infinite {
                  animation: marquee-scroll 40s linear infinite;
                }
              `}
            </style>
            <ul className="animate-marquee-infinite flex w-max items-center hover:[animation-play-state:paused]">
              {displayImages.map((image, i) => <li key={i} data-index={i} className="w-64 shrink-0 px-4 md:w-80 md:px-6">
                  <div className="group overflow-hidden rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm transition-all duration-300 hover:border-primary/50">
                    <img src={image} alt="Gallery image" className="aspect-video w-full object-cover opacity-70 transition-all duration-500 group-hover:scale-105 group-hover:opacity-100" />
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}